export function getAssetsUrl() {
  return process.env.NEXT_PUBLIC_ASSETS_URL?.trim().replace(/\/+$/, '') ?? '';
}

export function buildAssetsUrl(path: string) {
  const assetsUrl = getAssetsUrl();
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  return assetsUrl ? `${assetsUrl}${normalizedPath}` : normalizedPath;
}
